import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useMemo } from "react";
import { useAppLocale } from "./LocaleContext";
import { screenerCopyEn } from "@patient-watch/i18n/webapp/en-GB/screenerCopy";
import { screenerCopyDe } from "@patient-watch/i18n/webapp/de-DE/screenerCopy";
import { screenerCopyDa } from "@patient-watch/i18n/webapp/da-DK/screenerCopy";
import { screenerCopyEnUs } from "@patient-watch/i18n/webapp/en-US/screenerCopy";
import { screenerCopyFr } from "@patient-watch/i18n/webapp/fr-FR/screenerCopy";
import { screenerCopyIt } from "@patient-watch/i18n/webapp/it-IT/screenerCopy";
import { screenerCopyEs } from "@patient-watch/i18n/webapp/es-ES/screenerCopy";

type ScreenerCopy = typeof screenerCopyEn;

const screenerCopyByLocale: Record<SupportedLocale, ScreenerCopy> = {
    "en-GB": screenerCopyEn,
    "en-US": screenerCopyEnUs,
    "de-DE": screenerCopyDe,
    "da-DK": screenerCopyDa,
    "fr-FR": screenerCopyFr,
    "it-IT": screenerCopyIt,
    "es-ES": screenerCopyEs,
};

export function useScreenerCopy(): ScreenerCopy {
    const { locale } = useAppLocale();
    return useMemo(() => pickAppCopy(screenerCopyByLocale, locale), [locale]);
}
